import script from "./DetailSeccion.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailSeccion.vue?vue&type=script&lang=ts&setup=true"

import "./DetailSeccion.vue?vue&type=style&index=0&id=6c396a14&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c396a14"]])

export default __exports__